import React, { Component, Fragment } from "react"
import { NavLink } from 'react-router-dom'
import DevicesWidgetItem from './DevicesWidgetItem'
import { SORT } from '../../../Templates/functions'
import { renderSortingIcon, toggleSorting } from "../../../Templates/functions";
import SearchFilter from '../../../Templates/SearchFilter'
import { Skeleton } from '@material-ui/lab'
import { mediumCircleSkeleton, veryLongTextSkeleton,  } from '../../../Templates/icons'
import axios from 'axios'

const statusColor = {
    "Online": "#218b21",
    "Offline": "#cdcdcd",
}
class DevicesWidget extends Component {
    signal = axios.CancelToken.source()
    state = {
         sortingByName: 2,
        //sortingByActivityStatus: 1,
         //sortingByType: 2,
        filteredDevices: [],
        isLoading: true
    }

    componentDidMount = () => {
        this.loadDevices()
    }
    
    componentWillUnmount() {
        this.signal.cancel('Api is being canceled');
    }

    loadDevices = async () => {
        try {
            await this.props.fetchAllDevices(this.signal.token)
            this.setState({ isLoading: false })
        } catch (err) {
            if (axios.isCancel(err)) {
                console.info('Device Widget - ', err.message)
            } else {
                console.debug('Error', err.message)
            }
        }
    }

    filterDeviceList = (searchText) => {
        if (searchText === "") {
            this.setState(prevState => ({
                filteredDevices: [],
                filteringDevices: false
            }))
        }
        this.setState(prevState => ({
            filteredDevices: this.props.devices.filter(device => device.nickname.toLowerCase().includes(searchText) || device.name.toLowerCase().includes(searchText)),
            filteringDevices: true
        }))
    }
        
    render() {
        let devices = SORT(2, this.props.devices, "nickname")

        if (this.state.filteringDevices) {
            devices = this.state.filteredDevices
        }

        // if (this.state.sortingByName) {
        //     devices = SORT(this.state.sortingByName, devices, "nickname")
        // }
        if (this.state.sortingByName) {
            devices = SORT(this.state.sortingByName, devices, "nickname")
        }
        // if (this.state.sortingByType) {
        //     devices = SORT(this.state.sortingByType, devices, "type")
        // }

        const ghostItem = <div id="device-info-container">
            <div id="device-icon-image-container">
                {mediumCircleSkeleton}
            </div>
            {veryLongTextSkeleton}
        <div id="activity-status" className="flex-apart">
            <Skeleton animation="wave" height={10} width="100%" style={{ margin: "6" }} />
        </div>
        </div>

        return (
            <div className="feed-item shadow">
            <NavLink id="widget-link" className="flex-centered clickable FontSize20" to={`/dashboard/management/devices`}
                    draggable={false}><p className="action-text">DEVICE</p>
            </NavLink>
            <div className="flex-apart" id="widget-data-search-sort">
                <SearchFilter filterList={this.filterDeviceList} />
                <div className="flex" style={{alignItems: "center", color: "#777777" }}>
                        <div className="exception" onClick={() => toggleSorting(this.state.sortingByName, (value) => this.setState({ sortingByName: value }))}>
                        {renderSortingIcon(this.state.sortingByName)}
                    </div>
                </div>
            </div>
            <ul id="devices-list-container" className="overflow-y">
            {this.state.isLoading ? 
            <Fragment>
            {ghostItem}
            {ghostItem}
            {ghostItem}
            {ghostItem}
            {ghostItem}
            {ghostItem}
            {ghostItem}
            </Fragment>
            :
                devices.length > 0 ? devices.map(device => {
                    return <li key={device._id} id="device-info-container">
                        <DevicesWidgetItem
                                name={device.name}
                                nickname={device.nickname}
                                type={device.type}
                                status={device.activityStatus}
                                color={statusColor[device.activityStatus]}
                                />
                    </li>
                }) : null
            }
            </ul>
        </div>
        )
    }
}

export default DevicesWidget
